var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;



//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi-container/~/lodash/_Set.js
// module id = ./node_modules/victory-voronoi-container/node_modules/lodash/_Set.js
// module chunks = 1